var map = {
	"./locale-provider/ar_EG.tsx": 1082,
	"./locale-provider/bg_BG.tsx": 1086,
	"./locale-provider/ca_ES.tsx": 1090,
	"./locale-provider/cs_CZ.tsx": 1094,
	"./locale-provider/de_DE.tsx": 1098,
	"./locale-provider/el_GR.tsx": 1102,
	"./locale-provider/en_GB.tsx": 1106,
	"./locale-provider/en_US.tsx": 1110,
	"./locale-provider/es_ES.tsx": 1111,
	"./locale-provider/et_EE.tsx": 1115,
	"./locale-provider/fa_IR.tsx": 1119,
	"./locale-provider/fi_FI.tsx": 1123,
	"./locale-provider/fr_BE.tsx": 1127,
	"./locale-provider/fr_FR.tsx": 1131,
	"./locale-provider/is_IS.tsx": 1135,
	"./locale-provider/it_IT.tsx": 1139,
	"./locale-provider/ja_JP.tsx": 1143,
	"./locale-provider/ko_KR.tsx": 1147,
	"./locale-provider/ku_IQ.tsx": 1151,
	"./locale-provider/nb_NO.tsx": 1155,
	"./locale-provider/nl_BE.tsx": 1159,
	"./locale-provider/nl_NL.tsx": 1163,
	"./locale-provider/pl_PL.tsx": 1167,
	"./locale-provider/pt_BR.tsx": 1171,
	"./locale-provider/pt_PT.tsx": 1175,
	"./locale-provider/ru_RU.tsx": 1179,
	"./locale-provider/sk_SK.tsx": 1183,
	"./locale-provider/sl_SI.tsx": 1187,
	"./locale-provider/sr_RS.tsx": 1190,
	"./locale-provider/sv_SE.tsx": 1194,
	"./locale-provider/th_TH.tsx": 1198,
	"./locale-provider/tr_TR.tsx": 1202,
	"./locale-provider/uk_UA.tsx": 1206,
	"./locale-provider/vi_VN.tsx": 1210,
	"./locale-provider/zh_CN.tsx": 1214,
	"./locale-provider/zh_TW.tsx": 1217
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1081;


//////////////////
// WEBPACK FOOTER
// ./components ^\.\/locale-provider\/.+_.+\.tsx$
// module id = 1081
// module chunks = 0